import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import whiteBackArrow from '../../images/whiteBackArrow.svg';
import Input from '../../components/VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import ThankYou from './ThankYou';
import { parseQueryString } from '../../utils/utils';
import useTranslation from '../../hooks/use-translation';
import config from '../../config.json';
import lodash from 'lodash';
import apiRequest from '../../utils/api.request';
import { get_city_url } from '../../config.json';
import useLoader from '../../hooks/use-loader';
import getSource from '../../utils/get-source';
import { vaccinationApiRequestBody } from '../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';

import './vaccinationMobileWrapper.css';

const VaccinationWrapperMobile = () => {
  const [showInterest, _setShowInterest] = useState(true);
  const [showThanksPage, _setShowThanksPage] = useState(false);
  const [showLocationPage, _setShowLocationPage] = useState(false);
  const [response, _setResponse] = useState("");
  const [pin, _setPin] = useState("");
  const [city, _setCity] = useState("");
  const [state, _setState] = useState("");
  const [source, _setSource] = useState("");
  const [isOpen, _setIsOpen] = useState(false);
  const params = parseQueryString();
  const history = useHistory();
  const { showLoading, hideLoading, loadingCount } = useLoader();
  const [cityList, _setCityList] = useState([{ value: "", label: "select city" }]);
  const [error, _setError] = React.useState({
    interest: "",
    done: "",
    pinApi: "",
    pin: "",
    city: ""
  });
  const { t } = useTranslation();
  const user_details = useRef();
  const pin_input_ref = useRef();
  const capture_interest_url = config.covid_vacc_base_url + "v1/capture-interest/";

  const _captureInterest = async (interestValue) => {
    let result = false;
    let dataObj;

    if (interestValue === "Done") {
      dataObj = {
        "state": state,
        "city": city,
        "pincode": pin,
        "interest_value": "yes"
      }
    } else {
      dataObj = {
        "interest_value": interestValue
      }
    }

    dataObj = vaccinationApiRequestBody(dataObj, user_details.current);
    showLoading();
    const response = await apiRequest(capture_interest_url, dataObj, true, false, false, false, false, false, false, false, true);
    hideLoading();
    if (lodash.get(response, "status") !== "success") {
      if (interestValue === "Done") {
        _setError({
          ...error,
          done: (lodash.get(response, "response.data.message", "Something went wrong, please try again"))
        })
      } else {
        _setError({
          ...error,
          interest: (lodash.get(response, "response.data.message", "Something went wrong, please try again"))
        })
      }
    } else {
      result = true;
    }
    return result;
  }

  const getSourceId = async () => {
    const { source_id } = parseQueryString();
    if (source_id) {
      return Promise.resolve(source_id);
    }
    const sourceData = await getSource();
    return sourceData.source_id;
  }

  const _getCityList = async (pincode) => {
    try {
      const dataObj = {
        pincode: pincode
      }
      showLoading();
      if (pin_input_ref && pin_input_ref.current)
        pin_input_ref.current.blur();
      _setState("");
      _setCity("");
      const response = await apiRequest(get_city_url, dataObj, true, false, false, false, false, false, true, false, true);
      hideLoading();

      if (lodash.get(response, "status") !== "success") {
        _setError({
          ...error,
          pinApi: (lodash.get(response, "response.data.message", "Something went wrong, please try again"))
        })
      } else {
        const citylist = lodash.get(response, "pincodeData.data", []);

        if (citylist.length === 0) {
          _setError({
            ...error,
            pinApi: "Please enter a valid PIN code"
          })
        }
        const state = lodash.get(response, "pincodeData.data[0].state");
        _setState(state);
        let newList = [{ value: "", label: "select city" }];
        citylist.map((item) => {
          newList.push({ value: item.city, label: item.city });
        })
        _setCityList([...newList]);
      }
    } catch (err) {
      _setError({
        ...error,
        pinApi: (lodash.get(err, "response.data.message", "Something went wrong, please try again"))
      })
    }
  }

  const _handleYesClick = async () => {
    const res = await _captureInterest("yes");
    if (res) {
      if (pin !== "") _getCityList(pin);
      _setResponse("Yes");
      _setShowLocationPage(true);
    }
  }

  const _handleNoClick = async () => {
    const res = await _captureInterest("no");
    if (res) {
      _setResponse("No");
      _setShowInterest(false);
      _setShowThanksPage(true);
    }
  }

  const _handleVaccinatedClick = async () => {
    const res = await _captureInterest("already-vaccinated");
    if (res) {
      _setResponse("Vaccinated");
      _setShowInterest(false);
      _setShowThanksPage(true);
    }
  }

  const _handleDoneClick = async () => {
    const res = await _captureInterest("Done");
    if (pin.length !== 6) {
      _setError({
        ...error,
        pin: "please enter a valid PIN code"
      })
    } else if (city === "") {
      _setError({
        ...error,
        city: "please select a city"
      })
    } else if (res) {
      _setShowInterest(false);
      _setShowLocationPage(false);
      _setShowThanksPage(true);
    }
  }

  const _setPINCode = (pincode) => {
    if (pincode.length > 6) {
      return;
    } else {
      _setError({
        ...error,
        pin: "",
        pinApi: "",
      })
      _setPin(pincode);
      if (pincode.length === 6) _getCityList(pincode);
    }

  }

  const _cityInput = (e) => {
    _setError({
      ...error,
      city: ""
    })
    _setCity(e.target.value);
  };

  let auth_token;
  let source_id;
  let jhh_id;
  let user_name;
  let pin_code;

  useEffect(() => {
    getSourceId().then((sourceId) => {
      _setSource(sourceId);
      auth_token = lodash.get(params, "auth_token");
      source_id = lodash.get(params, "source_id") || sourceId;;
      jhh_id = lodash.get(params, "source_user_id");
      user_name = lodash.get(params, "t");
      pin_code = lodash.get(params, "pin", "");
      if (pin_code !== "") {
        _setPin(pin_code);
      }
      if (!auth_token || !source_id || !jhh_id || !user_name) {
        _setError(
          {
            ...error,
            interest: "Session expired, please login again",
          }
        )
      }
      else {
        user_name = atob(user_name);
        user_details.current = {
          auth_token,
          source_id: source_id.toLowerCase(),
          jhh_id,
        };
      }
    })
  }, [])

  return (
    <div className={loadingCount ? "eoi-mobile-wrapper eoi-opacity" : "eoi-mobile-wrapper"}>
      {lodash.get(params, "hide_header") !== "true" &&
        <div className="eoi-mobile-header">
          {lodash.get(params, "hide_back") !== "true" &&
            <a href={`vaccination-dashboard://healthhub.jio.com`}>
              <img className="white-back-arrow" src={whiteBackArrow} alt={t("BACK_ARROW")} />
            </a>
          }
          {t("EXPRESSION_OF_INTEREST")}
        </div>
      }
      <div className="eoi-mobile-body">
        {
          showInterest &&
          <div className="eoi-mobile-interest">
            <div className="eoi-mobile-interest-text">{t("PLEASE_SUBMIT_YOUR_INTEREST_FOR_COVID19_VACCINE_FOR")} {atob(lodash.get(params, "t", ""))}.</div>
            <div onClick={response === "Yes" ? () => { } : _handleYesClick} className={showLocationPage ? "eoi-mobile-interest-button-blue" : "eoi-mobile-interest-button"} >{t("EOI_YES")}</div>
            <div onClick={response === "Yes" ? () => { } : _handleNoClick} className={showLocationPage ? "eoi-mobile-interest-button-gray" : "eoi-mobile-interest-button"}>{t("EOI_NO")}</div>
            <div onClick={response === "Yes" ? () => { } : _handleVaccinatedClick} className={showLocationPage ? "eoi-mobile-interest-button-gray" : "eoi-mobile-interest-button"}>{t("EOI_ALREADY_VACCINATED")}</div>
            <div className="error-div">{error.interest}</div>
          </div>
        }
        {
          showLocationPage &&
          <div className="eoi-mobile-location">
            <div className="horizontal-line"></div>
            <div className="eoi-mobile-location-text">
              {t("WHICH_LOCATION_DO_YOU_WANT_TO_BE_VACCINATED_AT")}
            </div>
            <div className={(error.pinApi || error.pin) ? "eoi-mobile-location-inputs-div input-padding-zero" : "eoi-mobile-location-inputs-div"}>
              {t("PIN_CODE")}:
              <Input
                refVar={pin_input_ref}
                type="number"
                value={pin}
                onChange={(e) => _setPINCode(e.target.value)}
                addClassInput="eoi-mobile-location-input-box"
                addClassError="eoi-form-error"
                error={error.pinApi || error.pin}
              />
            </div>
            <div className={error.city ? "eoi-mobile-location-inputs-div input-padding-zero" : "eoi-mobile-location-inputs-div"}>
              {t("CITY")}:
              <Input
                onChange={_cityInput}
                value={typeof city !== undefined ? city : ""}
                type="select"
                selectOptions={cityList}
                addClassInput="eoi-mobile-location-input-box"
                addClassError="eoi-form-error"
                error={error.city}
              />
            </div>
            <div className="eoi-mobile-location-inputs-div">
              {t("STATE")}:
              <Input
                type="text"
                value={state}
                addClassInput="eoi-mobile-location-input-box state-input"
                readOnly={true}
              />
            </div>
            <Input
              type="button"
              addClassInput={(pin.length !== 6 || city === "") ? "eoi-mobile-location-button-disabled" : "eoi-mobile-location-button"}
              addClassError="error-div"
              value={t("DONE")}
              onClick={_handleDoneClick}
              disabledValue={(pin.length !== 6 || city === "")}
              error={error.done}
            />
          </div>
        }
        {
          showThanksPage &&
          <ThankYou response={response} hide_back={lodash.get(params, "hide_back")} source_id={source} iframeSrc={lodash.get(params, "iframeSrc")} />
        }
      </div>
    </div>
  );
};

export default VaccinationWrapperMobile;